module.exports = __webpack_public_path__ + "static/img/img3.ad7a598f.png";